<template>
  <div v-if="!showDetails">
    <div class="cashbox-searcher container container_30 fields-wrap search">
      <div class="row">
        <div class="input-wrap">
          <SelectField/>
        </div>
        <div class="input-wrap">
          <SelectField/>
        </div>
        <div class="input-wrap">
          <InputField/>
        </div>
      </div>
      <div class="row">
        <div class="input-wrap date-wrap">
          <date-field-flatpickr  title="Choose before this date"/>
        </div>
        <div class="input-wrap">
          <InputField/>
        </div>
        <div class="input-wrap date-wrap">
          <date-field-flatpickr  title="Choose before this date"/>
        </div>
      </div>
    </div>
    <md-table class="cashbox-list__table container container_30">
      <template v-if="!isLoading">
        <md-table-row class="cashbox-list_row">
          <md-table-head>hfg</md-table-head>
          <md-table-head>hfgh</md-table-head>
          <md-table-head>fsd</md-table-head>
          <md-table-head>sdfsf</md-table-head>
          <md-table-head>fsfs</md-table-head>
          <md-table-head>ID</md-table-head>
        </md-table-row>
        <template v-for="n in 10">
          <md-table-row class="cashbox-list__row table-row" :key="n" @dblclick="openDetails(1)">
            <md-table-cell class="cashbox-list__table-cell source-cell">
              some
            </md-table-cell>
            <md-table-cell class="cashbox-list__table-cell destination-cell">
              some
            </md-table-cell>
            <md-table-cell class="status-cell cashbox-list__table-cell">
              some
            </md-table-cell>
            <md-table-cell class="cashbox-list__table-cell requestor-cell"
              >some</md-table-cell
            >
            <md-table-cell class="cashbox-list__table-cell date-cell"
              >some</md-table-cell
            >
            <md-table-cell class="cashbox-list__table-cell id-cell"
              >some</md-table-cell
            >
            <md-tooltip md-direction="top"
              ><md-icon>info</md-icon>&nbsp;some</md-tooltip
            >
          </md-table-row>
        </template>
      </template>
      <template v-else-if="isLoading">
        <div class="cashbox-list__no-withdraws">
          <p>{{ i18n.lbl_loading() }}</p>
        </div>
      </template>
      <template v-else>
        <div class="cashbox-list__no-withdraws">
          <md-icon class="md-size-4x">local_atm</md-icon>
          <h2>{{ i18n.withdraw_no_withdrawals() }}</h2>
          <br />
          <p>{{ i18n.withdraw_no_withdrawals_desc() }}</p>
        </div>
      </template>
    </md-table>
  </div>
  <div v-else> 
    <div class="cashbox-details container container_30">
      <div class="md-title">Some title</div>
      <div class="details" v-for="n in 10" :key="`detail-${n}`">
        <p>Some key</p>
        <p>some value</p>
      </div>
      <div class="buttons">
          <md-button class="md-button btn md-primary md-theme-default" @click="closeDetails">Confirn</md-button>
          <md-button class="md-button btn md-primary md-theme-default" @click="closeDetails">Reject</md-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { i18n } from '@js/i18n'
import SelectField from '@com/fields/SelectField'
import InputField from '@com/fields/InputField'
import DateFieldFlatpickr from '../../common/fields/DateFieldFlatpickr.vue'
export default {
  data: _ => ({
    i18n,
    isLoading: false,
    id: null,
    showDetails: false
  }),
  components: {SelectField, InputField, DateFieldFlatpickr},
  methods: {
    openDetails (id) {
      this.id = id
      this.showDetails = true
    },
    closeDetails () {
      this.id = null
      this.showDetails = false
    }
  }
};
</script>

<style lang="scss" scoped>
.buttons {
  margin-top: 24px;
  display: flex;
  gap: 15px;
}
.details {
  display: flex;
  gap: 30px;
  margin-top: 24px;
}
.search {
  margin-bottom: 24px;
}
.table-row {
  cursor: pointer;
}
.row {
  display: flex;
  justify-content: space-between;
  .input-wrap {
    min-width: 400px;
  }
  .date-wrap {
    display: flex;
    &:last-child {
      justify-content: end;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/vue/app/widrawalRequest/WidrawalRequest.Index.vue